import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Categories from "@/pages/Categories";
import Game from "@/pages/Game";
import Result from "@/pages/Result";
import Daily from "@/pages/Daily";
import Profile from "@/pages/Profile";
import Ranking from "@/pages/Ranking";
import WhatIf from "@/pages/WhatIf";
import Conquistas from "@/pages/Conquistas";

function AppRoutes() {
  const location = useLocation();
  // Intercept the Google OAuth callback fragment BEFORE any protected route runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/entrar" element={<Auth />} />
      <Route path="/historias" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
      <Route path="/jogar/:category" element={<ProtectedRoute><Game /></ProtectedRoute>} />
      <Route path="/resultado/:sessionId" element={<ProtectedRoute><Result /></ProtectedRoute>} />
      <Route path="/desafio" element={<ProtectedRoute><Daily /></ProtectedRoute>} />
      <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/ranking" element={<ProtectedRoute><Ranking /></ProtectedRoute>} />
      <Route path="/e-se" element={<ProtectedRoute><WhatIf /></ProtectedRoute>} />
      <Route path="/conquistas" element={<ProtectedRoute><Conquistas /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App noise-overlay">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "rgba(15,15,20,0.92)",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "#F8FAFC",
                backdropFilter: "blur(12px)",
              },
            }}
          />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
